const state = {
  loaderStatus: false
}

const getters = {
  loaderStatus: (state) => state.loaderStatus
}

const mutations = {
  setLoader (state) {
    state.loaderStatus = true
  },
  unsetLoader (state) {
    state.loaderStatus = false
  }
}

const actions = {
  setLoaderStatus ({commit}, status) {
    commit(status ? 'setLoader' : 'unsetLoader')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loader.js